import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import HomeService from "../../../Services/HomeService";
import Swal from "sweetalert2";
import toast from "react-hot-toast";
import HttpClientXml from "../../../utils/HttpClientXml";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

function ManageBlog() {
  const userRole = localStorage.getItem("role");
  const userBlog = localStorage.getItem("blog");
  const loggedUserID = localStorage.getItem("uid");
  //   const [cities, setCities] = useState([]);
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(false);
  //   const [cityID, setCityID] = useState("");
  const [blogID, setBlogID] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState({
    categoryId: "",
    title: "",
    description: "",
    image: "",
  });

  const [blogCategories, setBlogCategories] = useState([])
  // Fetch blog categories
  const fetchBlogCategories = async () => {
    try {
      const res = await HomeService.getBlogCategory();
      if (res?.data) {
        setBlogCategories(res.data);
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  }

  const columns = [
    { name: "S.No.", selector: (row) => row.sln, sortable: true },
    // {
    //   name: "ID",
    //   cell: (row) => (
    //     <>
    //       <span
    //         title="Click to copy"
    //         onClick={() => handleCopy(row.id)}
    //         style={{ cursor: "pointer" }}
    //       >
    //         {row.id}
    //       </span>
    //     </>
    //   ),
    // },
    { name: "Category", selector: (row) => row.category, wrap: true },
    { name: "Blog Title", selector: (row) => row.title, wrap: true },
    { name: "Description", selector: (row) => row.description, wrap: true },
    {
      name: "Image",
      cell: (row) => (
        <img
          src={row.image || "placeholder-image-url"}
          alt={row.name}
          width="50"
          height="50"
        />
      ),
    },
    {
      name: "Action",
      cell: (row) => (
        <>
          <span title="Edit" onClick={() => handleEdit(row)}>
            <i
              className="fa-solid fa-pen-to-square"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "rgb(133, 218, 79)",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span>
          <span title="Delete" onClick={() => handleDelete(row.id)}>
            <i
              className="fa-solid fa-trash-can text-danger"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "#477DA5",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span>
        </>
      ),
    },
  ];

  const handleCopy = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        toast.success("Blog ID Copied");
      })
      .catch((err) => console.error("Error copying text: ", err));
  };

  const fetchAllBlogs = async () => {
    setLoading(true);
    try {
      const res = await HomeService.getBlogs();
      console.log(res.data);
      const arr = res?.data.map((ele, ind) => ({
        sln: ind + 1,
        category: ele?.category?.catName || "N/A",
        categoryId: ele?.category?._id || "",
        title: ele.title,
        description: ele.description,
        image: ele.image,
        id: ele._id,
      }));
      setBlogs(arr);
      if (userBlog) {
        setBlogs(arr.filter((item) => item.id === userBlog));
      }
    } catch (error) {
      console.error("Error fetching blogs:", error);
      toast.error("Failed to load blogs!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogCategories()
    fetchAllBlogs();
  }, []);

  const handleEdit = (row) => {
    setIsEdit(true);
    setEditData({
      categoryId: row.categoryId,
      title: row.title,
      description: row.description,
      image: row.image,
    });
    setBlogID(row.id);
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete Blog?",
      text: "Are you sure you want to delete this blog?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        await HomeService.deleteBlog(id);
        Swal.fire("Deleted!", "Blog has been deleted.", "success");
        fetchAllBlogs();
      } catch (error) {
        Swal.fire("Error!", "Failed to delete Blog.", "error");
      }
    }
  };

  const handleImageUpload = async (e) => {
    const data = new FormData();
    data.append("image", e.target.files[0]);
    try {
      const res = await HttpClientXml.fileUplode("image-upload", "POST", data);

      setEditData({ ...editData, image: res.image });
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = {
        title: editData.title,
        description: editData.description,
        image: editData.image,
      };
      if (isEdit) {
        await HomeService.updateBlog(blogID, data);
        toast.success("Blog updated successfully!");
      }
      setIsEdit(false);
      setEditData({ title: "", description: "", image: "" });
      fetchAllBlogs();
    } catch (error) {
      toast.error("Failed to save Blog.");
      console.error("Error saving Blog:", error);
    }
  };

  return (
    <>
      <div className="main_wrap" style={{ marginTop: "6rem" }}>
        <div className="container-fluid">
          {isEdit ? (
            <section className="chartBox_area">
              <h2>Edit Blog</h2>
              <hr />
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-4 mt-3">
                    <label>
                      Category<span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-control"
                      name="categoryId"
                      value={editData.categoryId}
                      onChange={(e) =>
                        setEditData({ ...editData, categoryId: e.target.value })
                      }
                    >
                      <option value="" disabled>---Select---</option>
                      {blogCategories.map((item, key) => (
                        <option key={key} value={item._id}>
                          {item?.catName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-8 mt-3">
                    <label>
                      Blog Title<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="cityName"
                      className="form-control"
                      value={editData.title}
                      onChange={(e) =>
                        setEditData({ ...editData, title: e.target.value })
                      }
                      placeholder="Enter Blog Title"
                    />
                  </div>

                  <div className="col-md-12 mt-3">
                    <label>
                      Blog Description<span className="text-danger">*</span>
                    </label>
                    <textarea
                      type="text"
                      id="cityName"
                      className="form-control"
                      value={editData.description}
                      onChange={(e) =>
                        setEditData({
                          ...editData,
                          description: e.target.value,
                        })
                      }
                      placeholder="Enter Blog Title"
                    />
                  </div>

                  <div className="col-md-12 mt-3">
                    <label>Upload Image</label>
                    {editData.image && (

                      <div>
                        <img src={editData.image} alt="Blog" style={{ margin: "10px 0", maxHeight: "100px" }} />
                      </div>
                    )}
                    <input
                      type="file"
                      id="inputGroupFile04"
                      className="form-control"
                      onChange={handleImageUpload}
                    />
                  </div>


                </div>
                <button type="submit" className="btn btn-primary mt-3">
                  Save Changes
                </button>
                <button type="button"
                onClick={()=>setIsEdit(false)}
                className="btn btn-secondary mt-3">
                  Cancel
                </button>
              </form>
            </section>
          ):(
            <>
            <div className="mt-5">
            <div style={headLineStyle} className="page-headline">
              Manage Blogs
            </div>
            {loading ? (
              <p>Loading...</p>
            ) : (
              <DataTable
                columns={columns}
                data={blogs}
                pagination
                responsive
                highlightOnHover
              />
            )}
          </div>
            </>
          )}

          
        </div>
      </div>
    </>
  );
}

export default ManageBlog;
